module.exports = __webpack_public_path__ + "img/filletting_mackerel.6fbb6c15.jpg";